
import { useMemberContext } from "./memberContext/MemberContext";
import { useStaleAwareDataContext } from "./useStaleAwareDataContext";


export const useMemberStaleAwareData = () => {
  const ctx = useMemberContext();
  
  return useStaleAwareDataContext({
    data: ctx.data,
    lastLoaded: ctx.lastLoaded,
    reload: ctx.reload,
    isLoading: ctx.isLoading
  });
};